import { render, staticRenderFns } from "./2todrive.vue?vue&type=template&id=01d8f9e4"
import script from "./2todrive.vue?vue&type=script&lang=js"
export * from "./2todrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports